"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberBalanceReceiptEntitySchema = exports.MemberCardBalancesSchema = exports.MemberBalanceReceiptSchema = exports.getMemberCardBalancesResponseSchema = exports.getMemberCardBalancesParamsSchema = exports.CustomerMemberCardItemSchema = exports.listMemberCardsResponseSchema = exports.listMemberCardsQuerySchema = void 0;
const zod_1 = require("zod");
const api_schemas_1 = require("../base/api.schemas");
const common_schemas_1 = require("../base/common.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
const members_schemas_1 = require("../merchant/members.schemas");
const membership_schemas_1 = require("./membership.schemas");
const _CustomerMemberCardItemSchema = zod_1.z.object({
    card_id: common_schemas_1.uuidSchema,
    merchant_id: zod_1.z.number().int().positive(),
    merchant_name: zod_1.z.string().min(1),
    logo_url: zod_1.z.string().url().nullable(),
    user_merchant_id: zod_1.z.number().int().positive(),
    member_since: timestamp_schemas_1.timestampIsoSchema,
    role: membership_schemas_1.MerchantRoleSchema,
    kind: zod_1.z.enum(['personal', 'group']),
    group_name: zod_1.z.string().min(1).max(100).nullable(),
    member_id: members_schemas_1.MerchantMemberCardEntitySchema.shape.member_id,
    revision: zod_1.z.number().int().positive(),
    background_image_url: zod_1.z.string().url().nullable(),
});
exports.listMemberCardsQuerySchema = zod_1.z.object({});
exports.listMemberCardsResponseSchema = (0, api_schemas_1.listResponseSchema)(_CustomerMemberCardItemSchema);
exports.CustomerMemberCardItemSchema = _CustomerMemberCardItemSchema;
const _MemberBalanceReceiptSchema = zod_1.z.object({
    amount_cents: common_schemas_1.moneyAmountSchema,
    received_at: timestamp_schemas_1.timestampIsoSchema,
});
const _MemberCardBalancesSchema = zod_1.z.object({
    card_id: common_schemas_1.uuidSchema,
    merchant_id: zod_1.z.number().int().positive(),
    prepaid: _MemberBalanceReceiptSchema.nullable(),
    bonus: _MemberBalanceReceiptSchema.nullable(),
});
exports.getMemberCardBalancesParamsSchema = zod_1.z.object({
    cardId: common_schemas_1.uuidSchema,
});
exports.getMemberCardBalancesResponseSchema = (0, api_schemas_1.dataResponseSchema)(_MemberCardBalancesSchema);
exports.MemberBalanceReceiptSchema = _MemberBalanceReceiptSchema;
exports.MemberCardBalancesSchema = _MemberCardBalancesSchema;
const _MemberBalanceReceiptEntitySchema = zod_1.z.object({
    receipt_id: common_schemas_1.uuidSchema,
    card_id: common_schemas_1.uuidSchema,
    merchant_id: zod_1.z.number().int().positive(),
    member_id_at_receipt: members_schemas_1.MerchantMemberCardEntitySchema.shape.member_id,
    balance_type: zod_1.z.enum(['prepaid', 'bonus']),
    amount_cents: common_schemas_1.moneyAmountSchema,
    received_at: timestamp_schemas_1.timestampIsoSchema,
    // Set for receipts entered by a merchant admin; null for externally supplied ones.
    submission_id: common_schemas_1.uuidSchema.nullable().default(null),
});
exports.MemberBalanceReceiptEntitySchema = _MemberBalanceReceiptEntitySchema;
